var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.68262C10.4316 4.68262 4.68262 10.4316 4.68262 17.5C4.68262 24.5684 10.4316 30.3174 17.5 30.3174C24.5684 30.3174 30.3174 24.5684 30.3174 17.5C30.3174 10.4316 24.5684 4.68262 17.5 4.68262ZM25.2793 16.2217C25.4434 14.9365 25.8467 13.6855 26.4688 12.5508C27.084 13.665 27.4941 14.9023 27.6582 16.2217H25.2793ZM27.665 18.7852C27.501 20.1045 27.084 21.3486 26.4688 22.4697C25.833 21.3281 25.4434 20.0908 25.2793 18.7852H27.665ZM24.8213 10.3359C23.6387 12.0859 22.9141 14.1162 22.7021 16.2217H18.7852V7.33496C21.1367 7.62891 23.2422 8.72266 24.8213 10.3359ZM16.2217 7.33496V16.2148H12.3047C12.0928 14.1094 11.3682 12.0791 10.1855 10.3291C11.7578 8.71582 13.8701 7.62891 16.2217 7.33496ZM7.33496 16.2217C7.49902 14.9023 7.91602 13.6582 8.53125 12.5439C9.16699 13.6787 9.56348 14.9229 9.7207 16.2217H7.33496ZM9.7207 18.7852C9.56348 20.084 9.16699 21.3281 8.53125 22.4629C7.90918 21.3486 7.49902 20.1045 7.33496 18.7852H9.7207ZM10.1787 24.6709C11.3613 22.9209 12.0859 20.8906 12.2979 18.7852H16.2148V27.665C13.8701 27.3711 11.7578 26.2842 10.1787 24.6709ZM18.7852 27.665V18.7852H22.6953C22.9072 20.8906 23.6318 22.9209 24.8145 24.6709C23.2354 26.2842 21.1299 27.3711 18.7852 27.665Z",
    fill: "#14171F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/basketball.4ca1eaf77ade3685c4f8b4b2b7dfaafa.svg";
export { ForwardRef as ReactComponent };